import { render } from "./FeedsView.vue?vue&type=template&id=d918b5d4&scoped=true"
import script from "./FeedsView.vue?vue&type=script&lang=js"
export * from "./FeedsView.vue?vue&type=script&lang=js"

import "./FeedsView.vue?vue&type=style&index=0&id=d918b5d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d918b5d4"]])

export default __exports__